/* ============================================================
   Build #255 — Djusie video hero
   ------------------------------------------------------------
   Lataa ja kaynnistaa videon vasta kun se tulee nakyviin.
   Videot ovat ~10 MB kappale, joten preload="none" + lazy start
   pitaa etusivun latauksen kevyena.

   Kaynnistaa VAIN nakyvissa olevan videon (mobiili tai desktop) —
   piilotettua ei ladata lainkaan.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function visible(el) {
    return el.offsetParent !== null;
  }

  function activate(video) {
    if (video.dataset.djusieStarted) return;
    video.dataset.djusieStarted = '1';
    // preload="metadata" hakee vain metadatan; load() aloittaa varsinaisen
    // latauksen vasta kun video on vierimassa nakyviin.
    video.load();
    if (!reduceMotion) {
      var p = video.play();
      // Selain voi estaa autoplayn — se ei haittaa, koska videossa on
      // `controls` (kuten affiliate-videoissa): kavija painaa itse playta
      // ja saa samalla aanen. Ei tarvita omaa aaninappia.
      if (p && p.catch) p.catch(function () {});
    }
  }


  function init(section) {
    var videos = section.querySelectorAll('.djusie-video-hero__video');
    if (!videos.length) return;

    var start = function () {
      Array.prototype.forEach.call(videos, function (v) {
        if (visible(v)) activate(v);
      });
    };

    if (!('IntersectionObserver' in window)) { start(); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        start();
        io.unobserve(e.target);
      });
    }, { rootMargin: '200px' });

    io.observe(section);

    // Ikkunan koon muutos voi vaihtaa nakyvan videon (mobiili <-> desktop)
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(start, 250);
    });
  }

  function boot() {
    document.querySelectorAll('[data-djusie-video]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: section lisataan/paivitetaan lennossa
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-djusie-video]');
    if (s) init(s);
  });
})();
